import { Component, OnInit } from '@angular/core';
import {AuthenticationService}from './../../service/auth/auth.service';
import { ActivatedRoute, Router, NavigationEnd, ActivationEnd, PRIMARY_OUTLET, RoutesRecognized } from '@angular/router';
import { filter } from 'rxjs/operators';
import { RoleService } from './../../service/admin/role/role.service';
import { map, mergeMap } from 'rxjs/internal/operators';
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent implements OnInit {
  breadcrumbs:any=[];
  public isCollapsed = false;
  me:any=[];
  Year:any;
  constructor(private auth:AuthenticationService,
              private router:Router,
              public service:RoleService,
              private activatedRoute: ActivatedRoute,

              ) {
                this.breadcrumsData();
                this.getMe();
                this.Year=new Date().getFullYear();

              }

  ngOnInit(): void {
  }

  logout(){
    this.auth.logout().subscribe((res:any)=>{
        this.router.navigate(['/wgiacm']);
    });
  }
  breadcrumsData() {
    this.router.events
      .pipe(filter(event => event instanceof ActivationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) { route = route.firstChild; }
        return route;
      }))
      .subscribe(route => {

        let snapshot = this.router.routerState.snapshot;
        this.breadcrumbs = [];
        let url = snapshot.url;


        let routeData = route.snapshot.data;
        this.breadcrumbs = routeData['breadcrumb'];
        //console.log(routeData);


      });


  }

  getMe(){
    this.service.getMe().subscribe((res:any)=>{
      this.me = res;
    });
  }

}
